import { ScheduleTypes } from '@frontend/api-schedule';
import { createStore, createShallowStore } from '@frontend/store';
import { getFilteredProvidersInCalendarViewLocationStorageKey } from '../views/Calendar/helpers';

export interface FilteredProvidersListStore {
  selectedProvidersList: ScheduleTypes.SchemaProvider[] | [];
  setSelectedProvidersList: (
    providersListData: ScheduleTypes.SchemaProvider[] | [],
    locationId: string,
    userId: string
  ) => void;
  resetSelectedProvidersList: (locationId: string, userId: string) => void;
}

export const useCalendarProvidersListStore = createStore<FilteredProvidersListStore>(
  (set) => ({
    selectedProvidersList: [],
    setSelectedProvidersList: (
      providersListData: ScheduleTypes.SchemaProvider[],
      locationId: string,
      userId: string
    ) => {
      // set only the providerIds in the local storage
      const filteredProviderIds = providersListData.map(({ id }) => id ?? '').filter((id) => id);
      localStorage.setItem(
        getFilteredProvidersInCalendarViewLocationStorageKey(locationId, userId),
        JSON.stringify(filteredProviderIds)
      );
      set({ selectedProvidersList: providersListData });
    },
    resetSelectedProvidersList: (locationId: string, userId: string) => {
      // Clear the local storage when the selected providers list is reset
      localStorage.removeItem(getFilteredProvidersInCalendarViewLocationStorageKey(locationId, userId));
      set({ selectedProvidersList: [] });
    },
  }),
  { name: 'filteredProvidersList' }
);

export const useProvidersListShallowStore =
  createShallowStore<FilteredProvidersListStore>(useCalendarProvidersListStore);
